<div
  class="row select-input {{ parentClass }} mb-{{ formMargin }}"
  [nbTooltip]="disabledInputTooltip"
  [nbTooltipDisabled]="!showDisabledInputTooltip"
>
  <app-custom-form-label
    *ngIf="selectInputLabel?.length > 0"
    [label]="selectInputLabel"
    [required]="required"
    [showInfoAsTooltip]="showInfoAsTooltip"
    [toolTip]="selectTooltipText"
    class="col-md-{{ labelColSize }} col-xs-12 weight-600 {{
      showInfoAsTooltip ? 'mt-2' : 'mt-0'
    }} {{ +labelColSize === 12 && +inputColSize === 12 ? 'mb-1' : 'mb-0' }}"
  ></app-custom-form-label>
  <div
    [ngStyle]="{
      pointerEvents: disableSelectInput ? 'none' : 'auto',
      opacity: disableSelectInput ? '0.5' : '1'
    }"
    class="col-md-{{
      inputColSize
    }} options-parent d-flex flex-column justify-content-center"
  >
    <div
      class="d-flex justify-content-between w-100 input-parent rounded select-popover-trigger custom-select-button cursor-pointer"
      [nbPopover]="optionsPopover"
      nbPopoverTrigger="click"
      nbPopoverAdjustment="vertical"
      nbPopoverPlacement="bottom"
      [nbSpinner]="showSpinner"
      nbPopoverClass="select-options-popover"
      (nbPopoverShowStateChange)="showStateChange($event)"
    >
      <!-- Placeholder for select input -->
      <span
        class="placeholder-text ml-3 mr-2"
        *ngIf="!selectedOptionsList?.length"
      >
        {{ selectInputPlaceholder }}
      </span>

      <!-- Showing selected options - tags/custom labels -->
      <ng-container *ngIf="selectedOptionsList?.length > 0">
        <div class="d-flex flex-wrap ml-3 mr-2">
          <app-tag-list
            *ngIf="
              selectedOptionsList?.length > 0 &&
              showTags &&
              !showSelectionsOutside
            "
            [optionsLimit]="tagLimit"
            [tagList]="selectedOptionsList"
            (tagRemove)="removeClicked($event)"
            [removable]="showRemovableOptionTags"
            [showEllipsedTags]="showLimitedTags"
            [showCombinedText]="showCombinedText"
          ></app-tag-list>

          <div *ngIf="!showSelectionsOutside && !multiple">
            <span
              class="weight-600"
              *ngFor="let option of selectedOptionsList; let i = index"
            >
              {{ option?.label }}
            </span>
          </div>

          <span *ngIf="showSelectionsOutside">
            {{ selectedOptionsList?.length }}
            {{
              selectedOptionsList?.length
                | pluralize: selectionTextLabel
                | lowercase
            }}
            selected
          </span>
        </div>
      </ng-container>

      <div class="d-flex align-items-center justify-content-end mr-1">
        <nb-icon
          *ngIf="selectedOptionsList?.length > 0 && showClearAllOptionsIcon"
          icon="close-outline"
          class="cursor-pointer mr-2"
          style="height: 80%"
          (click)="clearAllSelectedOptions()"
        ></nb-icon>

        <nb-icon
          [icon]="
            openOptionsPopover ? 'chevron-up-outline' : 'chevron-down-outline'
          "
          class="cursor-pointer"
        ></nb-icon>
      </div>
    </div>
    <ng-template #optionsPopover>
      <div class="p-3" *ngIf="showSearchBar">
        <input
          class="w-100"
          id="{{ searchInputId }}"
          [formControl]="searchString"
          nbInput
          type="search"
          fieldSize="small"
          (input)="getFilteredOptions()"
          placeholder="{{ searchInputPlaceholder }}"
          autocomplete="off"
          fullWidth
          appearances
        />
      </div>
      <div style="overflow-y: scroll; max-height: 19rem">
        <div *ngIf="showClearAllOption && multiple">
          <div
            class="pl-3 py-1 cursor-pointer"
            (click)="clearAllSelectedOptions()"
          >
            Clear Selection
          </div>
          <hr class="my-1" />
        </div>
        <div *ngIf="showSelectAll && multiple">
          <div class="pl-3 py-1">
            <nb-checkbox
              class="w-100 d-flex select-all-checkbox"
              [formControl]="selectAllControl"
              (checkedChange)="onSelectAllClick($event)"
            >
              Select All
            </nb-checkbox>
          </div>
          <hr class="my-1" />
        </div>
        <div
          class="d-flex w-100 py-2"
          *ngFor="let option of options; let i = index"
        >
          <nb-checkbox
            class="ml-3 w-100 cusor-pointer select-checkbox"
            [(checked)]="option.checked"
            (checkedChange)="changeSelectOptionValue($event, option)"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <nb-user
                  *ngIf="showUserComponent"
                  size="medium"
                  [name]="option?.value"
                  [picture]="option?.icon"
                  [showInitials]="true"
                  class="mr-3 facets-user user weight-600"
                >
                </nb-user>
                <nb-icon
                  *ngIf="showSuffixIcon && !showUserComponent"
                  style="width: 1.5rem !important; height: 1.5rem"
                  [icon]="option?.icon"
                  [pack]="option?.iconPack || 'fci'"
                ></nb-icon>
                <span class="ml-2" *ngIf="!showUserComponent">{{
                  option?.label
                }}</span>
              </div>
              <div
                *ngIf="showInfoIcon"
                class="mr-2"
                (click)="onInfoBtnClick($event, option)"
              >
                <nb-icon
                  [icon]="infoIcon"
                  pack="fci"
                  [status]="infoIconStatus"
                ></nb-icon>
              </div>
            </div>
          </nb-checkbox>
        </div>
      </div>
    </ng-template>
    <div
      *ngIf="
        showSelectionsOutside && showTags && selectedOptionsList?.length > 0
      "
      class="d-flex flex-wrap mt-2"
      style="overflow-y: scroll"
      [ngStyle]="{ 'max-height': selectionHeight }"
    >
      <app-tag-list
        [tagList]="selectedOptionsList"
        (tagRemove)="removeClicked($event)"
        [optionsLimit]="tagLimit"
        [removable]="showRemovableOptionTags"
        [showEllipsedTags]="showLimitedTags"
        [showCombinedText]="showCombinedText"
      ></app-tag-list>
    </div>
  </div>
</div>
